<script setup>
import Swal from 'sweetalert2';
import { inject } from 'vue';
import CreateTicketForm from '@/components/Dashboard/Support/CreateTicketForm.vue';

defineProps({
  ticketImpacts: {
    type: Array,
    required: true,
  },
  ticketUrgencies: {
    type: Array,
    required: true,
  },
  ticketRequestTypes: {
    type: Array,
    required: true,
  },
  applications: {
    type: Array,
    required: true,
  },
  users: {
    type: Array,
    required: true,
  },
  isPartner: {
    type: Boolean,
    default: true,
  },
  sendToOptions: {
    type: Array,
    default: [],
  },
});

const trans = inject('trans');

const submit = form => {
  form
    .transform(data => ({
      ...data,
      send_to: data.send_to?.id,
      application_1_id: data.application_1?.id,
      application_2_id: data.application_2?.id,
      impact: data.impact?.id ?? null,
      urgency: data.urgency?.id,
      request_type: data.request_type?.id,
      user_ids: data.impact?.id === 3 ? [data.user_ids?.id] : data.user_ids.map(user => user.id), // If the impact is individual user dont use .map()
    }))
    .post(route('dashboard.partner.support.store'), {
      preserveScroll: true,
      onSuccess: () => {
        form.reset();

        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: trans('__JSON__.Your request has been sent to partner support.'),
        });
      },
    });
};
</script>

<script>
import DashboardLayout from '@/Layouts/DashboardLayout.vue';

export default {
  layout: DashboardLayout,
};
</script>

<template>
  <create-ticket-form v-bind="$props" @submit="submit" />
</template>
